<template>
  <div class="text-icon">
    <img
      :src="icon"
      alt=""
      class="icon"
    >
    <p>{{ $t(text) }}</p>
  </div>
</template>
<script>
export default {
  name: "TextIcon",
  props: {
    text: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.text-icon {
  @include flex-align;
  flex-direction: column;
  justify-content: center;
  min-width: 70px;
  height: 70px;
  border-radius: 8px;
  background-color: var(--red-10);
  .icon {
    width: 32px;
  }
  p {
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1.5;
    color: var(--red-500);
  }
}
</style>